import { render } from "./GamePrizesEditor.vue?vue&type=template&id=515e6b97&scoped=true"
import script from "./GamePrizesEditor.vue?vue&type=script&lang=ts"
export * from "./GamePrizesEditor.vue?vue&type=script&lang=ts"

import "./GamePrizesEditor.vue?vue&type=style&index=0&id=515e6b97&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-515e6b97"

export default script